import { getClientSession } from 'shared/utils/auth/v2/client-session'

import { BearerInterceptor } from './bearer-interceptor'
import { ClientAuthRetryInterceptor } from './client-auth-retry-interceptor'
import { RetryInterceptor } from './retry-interceptor'
import { DynamicGrpcWebTransport } from 'shared/services/grpc/dynamic-grpc-web-transport'
import { isString } from 'shared/utils/type-guards'
import { StaticBearerInterceptor } from './static-bearer-interceptor'
import { ErrorHandlingInterceptor } from './error-handling-interceptor'
import { TracePropagationInterceptor } from './trace-propagation-interceptor'

export const makeWebTransport = (
  accessToken?: string,
): DynamicGrpcWebTransport => {
  const authInterceptor = isString(accessToken)
    ? new StaticBearerInterceptor(accessToken)
    : // transient errors are handled by the retry interceptor of "getClientSession". Adding it here would be overkill.
      new BearerInterceptor(() => getClientSession())

  return new DynamicGrpcWebTransport([
    new TracePropagationInterceptor(),
    authInterceptor,
    new ClientAuthRetryInterceptor(),
    new RetryInterceptor(),
    new ErrorHandlingInterceptor(),
  ])
}
